export default __webpack_public_path__ + "static/media/menu_white_24dp.389fd001.svg";